import React, { useEffect, useState } from 'react';
import { Checkbox, Divider } from 'antd';

const CheckboxGroup = Checkbox.Group;

const CheckboxPlus = (props)=>{

  const options = props.data || [];

  const [state, setState] = useState({
    checkedList: [],
    indeterminate: false,
    checkAll: false,
  });

  useEffect(()=>{
    let checked = props.value || [];
    setState({
      ...state,
      checkedList: checked,
      indeterminate: checked.length == 0 ? false : (checked.length < options.length),
      checkAll: checked.length === options.length,
    });
  }, [props.value])

  const onChange = checkedList => {
    props.onChange?.(checkedList);
  };

  const onCheckAllChange = e => {
    props.onChange?.(e.target.checked ? options.map(it=>it.value) : []);
  };

  return (
    <div>
      <div style={{ borderBottom: '1px solid #E9E9E9' }}>
        <Checkbox
          indeterminate={state.indeterminate}
          onChange={onCheckAllChange}
          checked={state.checkAll}
        >
          全选
        </Checkbox>
      </div>
      <CheckboxGroup
        options={options}
        value={state.checkedList}
        onChange={onChange}
      />
    </div>
  );
};

export default CheckboxPlus;


// WEBPACK FOOTER //
// ./src/components/Select/CheckboxPlus.js